function notfoundpage (){
    return(
        <>
          
            <h1>Not Found Page - Error 404</h1>
        
        </>
    );
}


 export default notfoundpage